import React from "react";

// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import WarningIcon from "@material-ui/icons/Warning";

// Other Files
import { colors } from "../../constants/colors";
import { customTheme } from "../../constants/customTheme";
import classNames from "classnames";

const QuitDialog = (props) => {
  const useStyles = makeStyles({
    root: customTheme(props.theme).dialog.root,
    title: customTheme().dialog.title,
    contentContainer: customTheme().dialog.contentContainer,
    contentItem: customTheme().dialog.contentItem,
    buttonContainer: customTheme().dialog.buttonContainer,
    buttonPrimary: customTheme(props.theme).buttonPrimary,
    buttonOutlined: customTheme(props.theme).buttonOutlined,
    titleIcon: {
      ...customTheme().titleIcon,
      color: colors.warning,
    },
  });

  const classes = useStyles();
  return (
    <Dialog
      open={props.open}
      PaperProps={{ className: classNames(classes.root) }}
    >
      <Typography
        className={classes.title}
        variant="h4"
        color="textPrimary"
        align="center"
      >
        <WarningIcon className={classes.titleIcon} />
        <span>Quit Study</span>
      </Typography>
      <DialogContent className={classes.contentContainer}>
        <Typography
          className={classes.contentItem}
          color="textPrimary"
          align="center"
        >
          Sample processing/saving is not finished. Quitting the study while a
          sample is processing can lead to data loss. Are you sure you want to
          quit this study?
        </Typography>
      </DialogContent>

      <DialogActions className={classes.buttonContainer}>
        <Button
          onClick={props.onClose}
          variant="outlined"
          className={classes.buttonOutlined}
        >
          Cancel
        </Button>
        <Button
          onClick={props.handleForceQuit}
          className={classes.buttonPrimary}
          variant="contained"
          color="primary"
        >
          Quit Study
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default QuitDialog;
